const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evaluate - evaluate metaTagFormTypeOptionsBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const sourceEvaluator = newSource => evaluateSource(newSource, content, parentContentPath, transientContext, nativeFunctions);
  const cacheKey = await sourceEvaluator(source.name);
  if (cacheKey === undefined) {
    return {};
  }
  const metaTagOptions = (await sourceEvaluator({
    type: 'getCacheValueBehavior',
    name: cacheKey
  })) || {};
  const formTypeOptions = {};
  Object.keys(metaTagOptions).forEach(key => {
    const {
      title,
      _created,
      children
    } = metaTagOptions[key];
    if (children !== undefined && Object.keys(children).length > 0) {
      formTypeOptions[key] = {
        title,
        _created
      };
    }
  });
  return formTypeOptions;
};
module.exports = {
  evaluate
};